'use strict';

import React from 'react';
import LocationStore from 'stores/LocationStore';
import LocationActions from 'actions/LocationActions';
import MediaActions from 'actions/MediaActions';
import {browserHistory} from 'react-router';

require('styles/LocationMore.scss');

class LocationMoreComponent extends React.Component {
  constructor(props) {
    super(props);
    let locationStore = LocationStore.getState();
    this.state = {
      locations: locationStore.locations, // 当前可选择的所有位置
      continent: locationStore.continent, // 当前选中的洲
      country: locationStore.country, // 当前选中的国家
      state: locationStore.state, // 当前选中的省
      city: locationStore.city,  // 当前选中的城市
      location: locationStore.location,
      query: '' // 过滤关键字
    };
    this.onLocationChange = this.onLocationChange.bind(this); // 数据有变
    this.onLocationInputChange = this.onLocationInputChange.bind(this); // 数据有变
    this.pickLocation = this.pickLocation.bind(this); // 选中某个位置
    this.locationsFilter = this.locationsFilter.bind(this); // 过滤 locations
  }
  componentDidMount() {
    LocationStore.listen(this.onLocationChange);
    LocationActions.fetchAllLocationList(); //加载全部location
    // goole anlaytics
    window.ga('set', 'page', this.props.location.pathname);
    window.ga('send', 'pageview');
  }
  componentWillUnmount() {
    LocationStore.unlisten(this.onLocationChange);
  }
  onLocationChange(state) {
    this.setState({
      locations: state.locations,
      continent: state.continent, // 当前选中的洲
      country: state.country, // 当前选中的国家
      state: state.state, // 当前选中的省
      city: state.city,  // 当前选中的城市
      location: state.location
    });
  }
  onLocationInputChange(e) {
    this.setState({query: e.target.value});
  }
  pickLocation(location) {
    LocationActions.updateLocation(location);
    // 更新 explore 页面分享标记
    MediaActions.updateShareTag();
    // 根据 LocationID 更新 MediaList
    MediaActions.updateLocationId(location._id, location.type);
    browserHistory.goBack();
  }
  locationsFilter(loc) {
    if(this.state.query) {
      let reg = new RegExp(this.state.query, 'i');
      return reg.test(loc.name);
    } else {
      return true;
    }
  }
  render() {
    return (
      <div className="locationmore-component">
        <div className="row .align-center header">
          <a className="columns text-white text-left small-4 pl-15" onClick={browserHistory.goBack}>返回</a>
          <span className="columns small-4 text-center">{this.state.location.name}</span>
          <a className="float-right text-white ml-20 visibility-hidden" onClick={browserHistory.goBack}>返回</a>
        </div>
        <div className="columns mt-10">
          <input type="text" autoFocus placeholder="过滤地名" onChange={this.onLocationInputChange} />
        </div>
        <ul className="columns accordion">
          {this.state.locations.filter(this.locationsFilter).map((loc)=>{
            if(loc.type !== 'more') {
              return (
                <li className="accordion-item" key={loc._id} onClick={this.pickLocation.bind(this, loc)}>
                  <div className="accordion-title">{loc.name}</div>
                </li>
              )
            }
          })}
        </ul>
      </div>
    );
  }
}

LocationMoreComponent.displayName = 'LocationMoreComponent';

// Uncomment properties you need
// LocationMoreComponent.propTypes = {};
// LocationMoreComponent.defaultProps = {};

export default LocationMoreComponent;



// WEBPACK FOOTER //
// ./src/components/LocationMoreComponent.js